enum BreakpointName {
	X_SMALL = 0,
	SMALL = 376,
	MEDIUM = 426,
	LARGE = 769,
	X_LARGE = 1025,
}

export default BreakpointName;